import type { ConfigOf } from "../../../install/types.ts";
import {
  Component,
  Element,
  InstallSpec,
  ItemComponent,
} from "../../../install/types.ts";

export const McpComponents = InstallSpec({
  gateway: ItemComponent({
    label: "Gateway",
    description: "Control access to MCP servers.",
    type: "string",
    maturity: "preview",
    schema: {
      url: Element({
        label: "MCP gateway URL",
        description: "MCP gateway URL; your servers will be hosted here.",
        type: "string",
      }),
      "oauth-endpoint": Element({
        label: "OAuth server endpoint",
        description:
          "OAuth server endpoint; must be publicly accessible and host .well-known/jwks.json.",
        type: "string",
      }),
    },
  }),
  server: ItemComponent({
    label: "MCP server",
    description:
      "Allows P0 to gate tool calls on MCP server backends via RBAC.",
    type: "string",
    maturity: "preview",
    schema: {
      gateway: Element({
        label: "Gateway",
        type: "dynamic",
        description: "The gateway that hosts this server",
        step: "new",
      }),
      path: Element({
        label: "Path",
        type: "string",
        description:
          "The server path relative to the gateway URL, e.g. 'github'",
        step: "new",
      }),
      hosting: Element({
        label: "Server type",
        description:
          "Whether this server proxies to an external server or hosts a containerized server.",
        type: "select",
        default: "upstream",
        options: {
          container: Component({
            label: "Container",
            description:
              "This server runs a Docker container to server requests",
            schema: {
              image: Element({
                label: "Docker image",
                type: "string",
              }),
            },
          }),
          upstream: Component({
            label: "Upstream",
            description:
              "This servers proxies requests to an upstream MCP server",
            schema: {
              url: Element({ label: "URL", type: "string" }),
            },
          }),
        },
      }),
      logoUrl: Element({
        label: "Logo URL",
        description: "An address of a logo image for the server.",
        type: "string",
        optional: true,
      }),
    },
  }),
});

export type McpIntegration = ConfigOf<typeof McpComponents>;
